import {
  Component,
  OnInit,
  ViewEncapsulation,
} from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormControl,
  UntypedFormGroup,
  Validators,
} from '@angular/forms';
import {
  BsModalRef,
  BsModalService,
} from 'ngx-bootstrap/modal';
import { environment } from 'src/environments/environment';
import { TenantId } from 'src/environments/environments.types';
import {
  InfoPageDialogComponent,
  InfoPageTemplate,
} from '..';
import { RegisterService } from '../../../services';
import { DialogResult } from '../../../types';

@Component({
  selector: 'app-invite-dialog',
  templateUrl: './invite-dialog.component.html',
  styleUrls: ['./invite-dialog.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class InviteDialogComponent implements OnInit {
  result: DialogResult | null = null;
  private form!: UntypedFormGroup;

  constructor(
    private modalService: BsModalService,
    private formBuilder: UntypedFormBuilder,
    private service: RegisterService,
    public bsModalRef: BsModalRef<InviteDialogComponent>
  ) {}

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
    });
  }

  submit(): void {
    this.form.markAllAsTouched();
    if (this.form.valid) {
      this.service
        .requestInvite(this.emailControl.value)
        .then(() => {
          this.result = { success: true };
          this.bsModalRef.hide();
        })
        .catch(() => {
          this.result = { success: false };
          this.bsModalRef.hide();
        });
    }
  }

  openDialog(pageTemplate: string): void {
    this.modalService.show(InfoPageDialogComponent, {
      class: 'modal-lg',
      initialState: {
        template: pageTemplate as InfoPageTemplate,
      },
    });
  }

  get emailControl(): UntypedFormControl {
    return this.form.get('email') as UntypedFormControl;
  }

  get tenant(): TenantId {
    return environment.tenant;
  }
}
